import axios from "axios";
import webConfig from "../config/config";
import { getLocalStorageWithExpiry } from "../core/utils/utils";
import { AUTH_LOCAL_STORAGE_KEY, USER_LOCAL_STORAGE_KEY } from "./core/AuthServices";

const axiosApi = axios.create({
  baseURL: webConfig.apiBaseUrl,
  timeout: 300000,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    accept: "application/json",
  },
});

// When useSsoBootstrap hydrates from a .k.net.mk cookie (no JWT in hand), it
// stores this placeholder so route guards see "logged in". The Axios layer
// must NOT send it as a Bearer — the cookie (via withCredentials) is the
// real auth in that case.
const SSO_COOKIE_PLACEHOLDER = "__sso_cookie__";

// Request interceptor to add token to headers
axiosApi.interceptors.request.use(
  (config) => {
    const auth = getLocalStorageWithExpiry(AUTH_LOCAL_STORAGE_KEY);

    if (auth && auth.token && auth.token !== SSO_COOKIE_PLACEHOLDER) {
      config.headers.Authorization = `Bearer ${auth.token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle unauthorized errors
axiosApi.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY);
      localStorage.removeItem(USER_LOCAL_STORAGE_KEY);
      if (window.location.pathname !== "/" && window.location.pathname !== "/sign-in") {
        window.location.href = "/";
      }
    }
    return Promise.reject(error);
  }
);

export default axiosApi;
